/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBrandLocations} from '../api'

 export const useQueryGetBrandLocations = createReactQueryHook('getBrandLocations', getBrandLocations)
